import { Box } from '@dixa/lib-shared-habla';
import { PropsWithChildren, PropsWithClassName } from 'lib-shared-types-utils';

interface Props extends PropsWithClassName, PropsWithChildren {}

export function ToggleBoxBody({
  children,
  className,
}: Props): JSX.Element | null {
  return (
    <Box padding="0 300 300" className={className}>
      {children}
    </Box>
  );
}
